import { Injectable } from '@angular/core';
import { filter, find, map, mergeMap, switchMap } from 'rxjs/operators';
import { RacePlan } from '../../season/race-plan/race-plan';
import { Driver } from '../drivers/driver';
import { combineLatest, Observable } from 'rxjs';
import { Ranking } from '../../season/rankings/ranking';
import { RacesService } from '../../season/races/races.service';
import { DriversService } from '../drivers/drivers.service';
import { RankingsService } from '../../season/rankings/rankings.service';

@Injectable({
  providedIn: 'root'
})
export class ResultsImport3Service {

  public readonly racePlans$: Observable<RacePlan[]> = this.racesService.racePlans$;

  constructor(
    private racesService: RacesService,
    private driversService: DriversService,
    private rankingsService: RankingsService
  ) {
  }

  loadRacePlan$(racePlanId?: RacePlan['_id']): Observable<[RacePlan, Ranking[], Observable<Driver[]>]> {
    let racePlan$: Observable<RacePlan>;
    if (racePlanId) {
      racePlan$ = this.racePlans$.pipe(
        switchMap(racePlans => racePlans),
        find(racePlan => racePlan._id === racePlanId)
      );
    } else {
      racePlan$ = this.racePlans$.pipe(
        filter(racePlans => !!racePlans?.length),
        mergeMap(racePlans => racePlans),
        find(racePlan => !!racePlan.resultsCouchDbName)
      );
    }
    return combineLatest([
      racePlan$,
      this.rankingsService.rankings$
    ]).pipe(
      map(([racePlan, rankings]: [RacePlan, Ranking[]]) => ([
        racePlan,
        rankings,
        this.driversService.requestDrivers$(racePlan, {pollingInterval: 10 * 1000})
      ]))
    );
  }
}
